// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getFetching } from '../attachments/attachmentsSelector';
import { getLinkType } from '../../../common/elements/utils/elementPropertyUtils';

// Components
import Spinner from '../../components/loaders/Spinner';
import Icon from '../../components/icons/Icon';

// Constants
import { LINK_ELEMENT_LINK_TYPES } from '../../../common/links/linkConstants';

// Styles
import './LinkStateDisplay.scss';

const getDefaultLinkIconName = (element) => {
    switch (getLinkType(element)) {
        case LINK_ELEMENT_LINK_TYPES.VIDEO:
            return 'link-video-icon';
        case LINK_ELEMENT_LINK_TYPES.AUDIO:
            return 'link-audio-icon';
        case LINK_ELEMENT_LINK_TYPES.MAP:
            return 'link-map-icon';
        default:
            return 'link-icon';
    }
};

const LinkStateDisplay = ({ element, attachment }) => {
    const fetching = !element.getIn(['content', 'link', 'url']) && getFetching(attachment);
    const error = element.getIn(['content', 'temp', 'error']);

    let displayElement = <Icon name={getDefaultLinkIconName(element)} />;

    if (error) {
        displayElement = <Icon name="link-fail" />;
    }

    if (fetching) {
        displayElement = <Spinner show strokeWeightMultiplier={2} />;
    }

    return <div className="LinkStateDisplay">{displayElement}</div>;
};

LinkStateDisplay.propTypes = {
    element: PropTypes.object,
    attachment: PropTypes.object,
};

export default LinkStateDisplay;
